import React from 'react';
import './notifier.scss';
import { Icon, LinkText, NotifierAccordion, Typography } from "../../index";
import { Toast, ToastHeader } from 'reactstrap';

export const Notifier = ({
    accordion,
    className,
    colorStyle = "alert",
    children,
    heading,
    link,
    icon = null,
    show,
    variant = 'inline'
}) => {

    const messageType = {
        inline: 'body-02',
        banner: 'body-01',
    };

    const messageColor = {
        inline: {
            alert: {
                iconColor: '$color-primary-a3',
                msgColor: '$color-primary-a2'
            },
            error: {
                iconColor: '$color-system-b1',
                msgColor: '$color-primary-a2'
            },
            success: {
                iconColor: '$color-system-a1',
                msgColor: '$color-primary-a2'
            }
        },
        banner: {
            alert: {
                iconColor: '$color-primary-a2',
                msgColor: '$color-primary-a2'
            },
            error: {
                iconColor: '$color-primary-c1',
                msgColor: '$color-primary-c1'
            },
            success: {
                iconColor: '$color-primary-c1',
                msgColor: '$color-primary-c1'
            }
        }
    };

    const iconContent = icon
        ? <div className="bsw-notifier__icon">
            <Icon name={icon}
                size="medium"
                color={messageColor[variant][colorStyle]['iconColor']}
            />
        </div>
        : null;

    const headingContent = heading
        ? < Typography
            bold
            tag="div"
            type={"heading-01"}
            color={messageColor[variant][colorStyle]['msgColor']}
            responsive
        >
            {heading}
        </Typography>
        : null;

    const bodyContent = children
        ? <div className="bsw-notifier__message-body">
            <Typography
                tag="div"
                type={messageType[variant]}
                color={messageColor[variant][colorStyle]['msgColor']}
                responsive
            >
                {children}
            </Typography>
        </div>
        : null;

    const linkContent = link
        ? <div className="bsw-notifier__message-link" >
            <LinkText
                href={link.href}
                to={link.to}
                onClick={link.onClick}
                decorator="none"
                target={link.target}
                as={link.as}
            >
                <div className="bsw-notifier__message-link-label">
                    <Typography
                        type={messageType[variant]}
                        color={messageColor[variant][colorStyle]['msgColor']}
                        bold
                        responsive
                    >
                        {link.label}
                    </Typography>
                </div>
                <div className="bsw-notifier__message-link-icon">
                    <Icon name="arrow" color={messageColor[variant][colorStyle]['msgColor']} />
                </div>
            </LinkText>
        </div>
        : null;

    const notifierClasses = [
        `bsw-notifier`,
        `bsw-notifier--${variant}`,
        `bsw-notifier-color--${colorStyle}`,
        `${accordion ? `bsw-notifier--accordion` : ''}`,
        `${className ? className : ''}`
    ].join(' ');

    return <>
        <Toast
            className={notifierClasses}
            isOpen={show}
        >
            <ToastHeader>
                <div className="bsw-notifier__content">
                    {accordion
                        ? <NotifierAccordion
                            accordion={accordion}
                            iconContent={iconContent}
                            headingContent={headingContent}
                            bodyContent={bodyContent}
                            linkContent={linkContent}
                        />
                        : <>
                            {iconContent}
                            <div className="bsw-notifier__message">
                                <div className="bsw-notifier__message-content">
                                    {headingContent &&
                                        <div className="bsw-notifier__message-heading">
                                            {headingContent}
                                        </div>
                                    }
                                    {bodyContent}
                                </div>
                                {linkContent}
                            </div>
                        </>
                    }
                </div>
            </ToastHeader>
        </Toast>
    </>;
}